<template >
    <div>
        <template v-for="menu in menus">
            <el-button :type="menu.css==''?'primary':menu.css"  @click="handleclick(menu.linkurl)" :key="menu.id" v-if="ignore_ids.indexOf(','+menu.id+',')<0" size="medium" :icon="getMenuIcon(menu.name)">
                {{menu.name}}
            </el-button>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        menu_id: {
            type: Number,
            default() {
                return 0
            }
        },
        menus: {
            type: Array,
            default() {
                return 0
            }
        },
        ignore_ids: {
            type: String,
            default() {
                return ''
            }
        }
    },
    methods: {
        getMenuIcon(name) {
            if (!name) return ''
            if (name.indexOf('添加') >= 0) return 'el-icon-plus'
            if (name.indexOf('新增') >= 0) return 'el-icon-plus'
            if (name.indexOf('查看') >= 0) return 'el-icon-search'
            if (name.indexOf('编辑') >= 0) return 'el-icon-edit'
            if (name.indexOf('导出') >= 0) return 'el-icon-download'
            if (name.indexOf('导入') >= 0) return 'el-icon-upload2'
            if (name.indexOf('删除') >= 0) return 'el-icon-delete'
            if (name.indexOf('附件') >= 0) return 'el-icon-paperclip'
            return ''
        },
        handleclick(params){
            this.$emit('on_btnclk',params);
        },
    }
}
</script>